var $8460c13bb2d75345$exports = {};
$8460c13bb2d75345$exports = {
  "alpha": "Alpha",
  "black": "musta",
  "blue": "Sininen",
  "blue purple": "sinivioletti",
  "brightness": "Kirkkaus",
  "brown": "ruskea",
  "brown yellow": "ruskeankeltainen",
  "colorName": function colorName(args) {
    return "".concat(args.lightness, " ").concat(args.chroma, " ").concat(args.hue);
  },
  "cyan": "syaani",
  "cyan blue": "syaaninsininen",
  "dark": "tumma",
  "gray": "harmaa",
  "grayish": "harmahtava",
  "green": "Vihre\xE4",
  "green cyan": "vihre\xE4nsyaani",
  "hue": "S\xE4vy",
  "light": "vaalea",
  "lightness": "Valom\xE4\xE4r\xE4",
  "magenta": "magenta",
  "magenta pink": "magentapinkki",
  "orange": "oranssi",
  "orange yellow": "oranssinkeltainen",
  "pale": "vaalea",
  "pink": "pinkki",
  "pink red": "vaaleanpunainen",
  "purple": "violetti",
  "purple magenta": "violettimagenta",
  "red": "Punainen",
  "red orange": "punaoranssi",
  "saturation": "V\xE4rikyll\xE4isyys",
  "transparentColorName": function transparentColorName(args) {
    return "".concat(args.lightness, " ").concat(args.chroma, " ").concat(args.hue, ", ").concat(args.percentTransparent, " l\xE4pin\xE4kyv\xE4");
  },
  "very dark": "hyvin tumma",
  "very light": "eritt\xE4in vaalea",
  "vibrant": "eloisa",
  "white": "valkea",
  "yellow": "keltainen",
  "yellow green": "keltavihre\xE4"
};
export { $8460c13bb2d75345$exports as default };